import * as z from 'zod';

import { noteContextTypeSchema } from './notes-query-schema';

export const noteMutationSchema = z.object({
  context_id: z.number(),
  context_type: noteContextTypeSchema,
  message: z.string().min(1, 'Message is required'),
});

export type NoteMutationSchema = z.infer<typeof noteMutationSchema>;

export const noteDeleteSchema = z.object({
  id: z.number(),
});

export type NoteDeleteSchema = z.infer<typeof noteDeleteSchema>;

export const noteUpdateSchema = z.object({
  id: z.number(),
  message: z.string().min(1, 'Message is required'),
});

export type NoteUpdateSchema = z.infer<typeof noteUpdateSchema>;

export const notesFormSchema = z.object({
  message: z.string().min(1, 'Message is required'),
});

export type NotesFormSchema = z.infer<typeof notesFormSchema>;
